export const transformQuotes = (quotes: any) => {
  if (!Array.isArray(quotes)) {
    console.warn("transformQuotes: quotes não é um array válido:", quotes);
    return [];
  }

  const quotesFormated = [];

  quotes.forEach((quote: any) => {
    // Verificação de segurança para garantir que quote seja um objeto válido
    if (!quote || typeof quote !== "object") {
      console.warn("transformQuotes: quote inválido ignorado:", quote);
      return;
    }

    let freetime = {
      import: {
        dem: "-",
        det: "-",
      },
      export: {
        det: "-",
      },
    };
    let transPorts = [];

    switch (quote.type) {
      case "msc":
        transPorts = [];
        if (quote.sailing_info?.otherInfos?.freeTimes) {
          freetime = {
            import: {
              dem: `${quote.sailing_info.otherInfos.freeTimes.import
                ?.find((item) => item.type === "Import Combined")
                ?.text.split(" ")[0]
                } days`,
              det:
                quote.sailing_info.otherInfos.freeTimes.import.length > 1
                  ? `${quote.sailing_info.otherInfos.freeTimes.import
                    .find((item) => item.type !== "Import Combined")
                    ?.text.split(" ")[0]
                  } days`
                  : "-",
            },
            export: {
              det: `${quote.sailing_info.otherInfos.freeTimes.export[0]?.text.split(
                " "
              )[0]
                } days`,
            },
          };
        }

        const scheduleInformation =
          quote.sailing_info?.otherInfos?.scheduleInformation;

        if (
          scheduleInformation?.oceanTranshipmentMode !== "Direct" &&
          scheduleInformation?.legsDetails
        ) {
          scheduleInformation.legsDetails.map((r: any) => {
            transPorts.push(r.arrivalPortName);
          });
        }

        quotesFormated.push({
          ...quote,
          freetime,
          transhipment:
            scheduleInformation?.oceanTranshipmentMode === "Direct"
              ? "Direct"
              : transPorts,
        });
        break;
      case "cmacgm":
        transPorts = [];

        // Verificação de segurança para sailing_info
        if (quote.sailing_info?.otherInfos?.detentionDemurrage) {
          freetime = {
            import: {
              dem: `${quote.sailing_info.otherInfos.detentionDemurrage
                .ImportDetentionDemurrageDetails?.[0]?.NoOfFreeDays || 0
                } days`,
              det:
                quote.sailing_info.otherInfos.detentionDemurrage
                  .ImportDetentionDemurrageDetails?.length > 1
                  ? `${quote.sailing_info.otherInfos.detentionDemurrage
                    .ImportDetentionDemurrageDetails[1]?.NoOfFreeDays || 0
                  } days`
                  : "-",
            },
            export: {
              det: `${quote.sailing_info.otherInfos.detentionDemurrage
                .ExportDetentionDemurrageDetails?.[0]?.NoOfFreeDays || 0
                } days`,
            },
          };
        }

        if (quote.sailing_info?.otherInfos?.router) {
          const transboardTemp = [];

          quote.sailing_info.otherInfos.TranShipment?.map((item) => {
            transboardTemp.push(item.split(",")[0]);
          });
          transPorts = transboardTemp;
        }
        quotesFormated.push({
          ...quote,
          freetime,
          transhipment: transPorts.length > 0 ? transPorts : "Direct",
        });
        break;
      case "maersk":
        transPorts = [];

        if (
          quote.values?.filter(
            (item: any) =>
              item.category_name.toLowerCase() === "detention"
          ).length > 0
        ) {
          const daysFreetime = Number(quote.values.filter(
            (item: any) =>
              item.category_name.toLowerCase() === "detention"
          )[0].category.split(" -")[0].trim().slice(-1)) - 1;
          freetime = {
            import: {
              dem: `${daysFreetime
                } days`,
              det: "-",
            },
            export: {
              det: `${getImportFreetimeFromTable(
                quote.type,
                quote?.from_code
              )} `,
            },
          };
        } else {
          freetime = {
            import: {
              dem: "-",
              det: "-",
            },
            export: {
              det: `${getImportFreetimeFromTable(
                quote.type,
                quote?.from_code
              )}`,
            },
          };
        }
        if (quote.sailing_info?.otherInfos?.lastDischargePort && quote.sailing_info?.otherInfos?.toLocation) {
          if (quote.sailing_info?.otherInfos?.lastDischargePort.cityName !== quote.sailing_info?.otherInfos?.toLocation.cityName) {
            transPorts.push(quote.sailing_info?.otherInfos?.toLocation.cityName);
          }
        }
        quotesFormated.push({
          ...quote,
          freetime,
          transhipment: transPorts.length > 0 ? transPorts : "Direct",
        });
        break;
      default:
        freetime = {
          import: {
            dem: "-",
            det: "-",
          },
          export: {
            det:
              getImportFreetimeFromTable(quote.type, quote?.from_code) || "-",
          },
        };
        quotesFormated.push({
          ...quote,
          freetime,
          transhipment: "Direct",
        });
    }
  });
  return quotesFormated;
};

export const getImportFreetimeFromTable = (type: string, portCode: string) => {
  const table = {
    maersk: 7,
    msc: 5,
    zim: 7,
    hapag: 5,
    one: 6,
    hapagspot: 5,
  };
  const normalizedType = type?.toLowerCase();

  if (portCode?.substring(0, 2) === "BR") {
    return `${table[normalizedType]} days`;
  }
  return "-";
};
